<div class="chat-width-a">
  <h2 mat-dialog-title class="md-title chat-cont-a">
    <img
      src="../../assets/images/logoclaro2.png"
      style="width: 32px; height: 32px; vertical-align: middle"
    />
    <label class="labTitle chatTitle-b"
      >T&eacute;rminos y Condiciones - Reglas de Redención</label
    >
  </h2>
  <mat-dialog-content class="chat-cont-a">
    <div class="chatJAC">
      <div class="popupbg">
        <div class="popupcont f-reg f-black roboto-r">
          <div class="termr-t">
            <h2 style="text-align: center; padding-bottom: 10px">
              Programa Refiere y Gana
            </h2>
            <h4 style="text-align: center; color: #ef3829">
              Términos y Condiciones- Reglas de Redención
            </h4>
            <br />
            <h5 style="overflow: hidden">I. Descripción del Programa</h5>
            El Programa de Referidos (en adelante, el Programa) permite que
            cualquier cliente activo de Claro pueda referir nuevos clientes
            (sean éstos familiares, amigos o conocidos) sin importar el tiempo
            que lleve como cliente en Claro. Tanto el cliente existente, como la
            persona referida, podrían disfrutar de un descuento que está
            condicionado a que el cliente referido complete la adquisición del
            producto o servicio participante en el Programa. A continuación, se
            detallan las reglas de participación del Programa según el producto
            o servicio para el cual el cliente prospecto haya sido referido.
            <br /><br />
            <h5 style="overflow: hidden">
              II. Condiciones para participar en el Programa
            </h5>
            Para poder participar y disfrutar de los beneficios del programa
            deben cumplirse las siguientes condiciones:
            <br />
            1. Cliente que refiere-
            <br />
            • Debe estar suscrito a Mi Claro. <br />
            • Debe estar suscrito
            a facturación electrónica. <br />
            • Tener cuenta activa con balance
            al corriente. <br />
            • Estar activo en una cuenta Móvil “Update” o
            venta a plazos, BYOP Credit Limit o Servicio de Internet y
            Televisión 2 Play y 3 Play, con contrato de 24 meses. <br />
            • Referir amigos, familiares amigos o conocidos a través del enlace
            del Programa de Referidos en Mi Claro. No existirá límite de
            referidos. <br />
            • Redimir beneficios cuando se encuentren
            disponibles en su cuenta del Programa. <br />
            • Aceptar los términos
            y condiciones del programa.
            <br />
            2. Cliente referido-
            <br />
            • Debe suscribirse a uno de los productos requeridos en el
            Programa de Referidos.
            <br />
            • Activar una cuenta Móvil “Update” o
            venta a plazos, BYOP Credit Limit o Servicio de Internet y
            Televisión 2 Play y 3 Play con contrato de 24 meses.
             <br />
             • Debe
            suscribirse a Mi Claro. 
            <br />
            • Debe suscribirse a facturación
            electrónica.
             <br />
            • Aceptar los términos y condiciones del
            Programa.
             <br />
             • Redimir beneficios cuando se encuentren
            disponibles en su cuenta del Programa en Mi Claro. 
            <br />
            • Mantener
            cuenta activa con balance corriente para redimir sus beneficios.
            <br />
            • Puede referir amigos familiares o conocidos familiares,
            amigos o conocidos a través del enlace del Programa de Referidos en
            Mi Claro. No existirá límite de referidos.
            <br />
            <br />

            <h5 style="overflow: hidden">III. Aplicación del beneficio</h5>
            1. Cliente que refiere-
            <br />
            • Recibirá un cupón de descuento que al ser redimido le
            representará el beneficio correspondiente al servicio de la cuenta
            que origina el referido. 
            <br />
            a. Móvil Update- Cupón de $50 de
            descuento $50 para pago de su factura 
            <br />
            b.BYOP Credit Limit- Cupón de $25 de descuento paga pago de su
            factura.
            <br />
             c. FIJO- Cupón de 50% de descuento en la renta del plan fijo en cuentas
             2Play y 3Play (No aplica a cargos reglamentarios, cargos por franquicia,
             IVU, cargos por STB, canales Premium, canales de adultos y paquetes
             complementarios.)
            <br />
             d. . Individual Residencial (Cuentas Convergentes) – 50% de descuento en
             la renta del plan fijo (El descuento se incluye al plan de <a class="ClaroTv">Claro</a
            ><a class="tvmas">tv+</a> , si la cuenta es 3Play.) 
            <br />
            • El cliente existente podrá disfrutar su cupón de descuento a partir del octavo día
            de la fecha de activación de su servicio Móvil “Update”, BYOP “Credit Limit” o una
            vez se complete la instalación del servicio fijo y se genere su primera factura.
            <br />
            • La aplicación de su descuento solo podrá ser gestionada a través de la cuenta del
            cliente del Programa de Referidos en Mi Claro.
            <br />
            • No se podrá utilizar el beneficio en combinación con otras promociones u ofertas.
            <br />
            • El cupón de descuento no se utilizará como crédito o reembolso a cuenta en caso
            de cancelación.
            <br />
            • Los cupones de descuentos no son transferibles.
            <br />
            • Una vez acepte redimir su cupón de descuento el mismo perderá su validez, este
            no podrá ser cancelado, reversado o reembolsado.  
            <br />
            
            • En el caso de los descuentos para cuentas Móvil Update y BYOP Credit Limit y solo
            podrá redimir un cupón por factura.
            <br />
            
            a. Si el valor del cupón de descuento redimido es mayor al balance
            pendiente de su factura Móvil Update o BYOP Credit Limit, al redimir
            este descuento el cliente perderá la diferencia del valor restante.
            <br />
            b. Si el valor del cupón de descuento redimido es menor al balance
            pendiente de su factura Móvil Update o BYOP Credit Limit, el cliente es
            responsable de pago remanente de su factura en o antes de la fecha de
            vencimiento.
            <br />
            c. Solo se podrá redimir un cupón de descuento para las cuentas Fijo
            (2Play, 3Play) y el mismo se reflejará en su próximo ciclo de factura.
            <br />
            • Al momento de redimir su beneficio es importante que la cuenta NO esté
            suspendida o con atrasos. De estarlo, el cliente debe poner la cuenta al corriente
            para poder redimir su beneficio
            <br />
            • El beneficio expira en un período de 12 meses.
            <br />
            • La fecha de expiración del cupón de descuento será calculada tomando como inicio
            la fecha de envío del cupón.
            <br />
            • Cliente debe gestionar la redención de su cupón de descuento a través de Mi Claro.
            <br />
            • Claro no se hace responsable por cupones no redimidos por el cliente. 
            <br />


            2. Cliente referido
            <br />
            • Para reclamar su beneficio, debe llevar copia impresa o digital de la invitación al
            Programa recibido, que muestre el código del cupón, al momento de la activación
            de su nuevo servicio móvil o fijo o hacer mención del mismo si se solicita activación
            de línea fijo por teléfono
            <br />
            • Activar uno de los productos o servicios aplicables del Programa. Estos son: Móvil
            “Update”, BYOP Credit Limit, Servicio de Internet y Televisión 2 Play y 3 Play con
            contrato de 24 meses.
            <br />
            • Al suscribirse a uno de los servicios participantes, el cliente podría recibir el
            descuento que corresponda al servicio de la cuenta que adquirió.
            <br />
            a. Móvil Update- Cupón de $50 de descuento $50 para pago de su factura
            <br>
            b. BYOP Credit Limit- Cupón de $25 de descuento paga pago de su
            factura 
            <br />
            c. FIJO- Cupón de 50% de descuento en la renta del plan fijo en cuentas
            2Play y 3Play (No aplica a cargos reglamentarios, cargos por franquicia,
            IVU, cargos por STB, canales Premium, canales de adultos y paquetes
            complementarios.)
            <br />
            d. Individual Residencial (Cuentas Convergentes) – 50% de descuento en
            la renta del plan fijo (El descuento se incluye al plan de
            <a class="ClaroTv">Claro</a><a class="tvmas">tv+</a> , si la cuenta
            es 3Play.)
            <br />
            e. GPON- la aplicación de términos, condiciones y beneficios se aplicará como sigue:
            <br />
            • Fijo 2PLAY (solo GPON): (No aplica a cargos reglamentarios, cargos por franquicia, IVU, cargos por STB, canales
            Premium, canales de adultos y paquetes complementarios.) <br>
            • Fijo 3PLAY (solo GPON): (No aplica a cargos reglamentarios, cargos por franquicia, IVU, cargos por STB, canales
            Premium, canales de adultos y paquetes complementarios.) <br>
            • Individual Residencial (Cuentas Convergentes – Solo GPON): (No aplica a cargos reglamentarios, cargos por
            franquicia, IVU, cargos por STB, canales Premium, canales de adultos y paquetes complementarios.)
            <br>



            • La aplicación de su descuento solo podrá ser
            gestionada a través de la cuenta del cliente del Programa de
            Referidos en Mi Claro. 
            <br />• No se podrá utilizar el beneficio en
            combinación con otras promociones u ofertas. 
            <br />• El cupón de
            descuento no se utilizará como crédito o reembolso a cuenta en caso
            de cancelación. 
            <br />
            • Los cupones de descuentos no son
            transferibles. 
            <br />
            • Una vez aplique su cupón de descuento el
            mismo perderá su validez, este no podrá ser cancelado, reversado o
            reembolsado.
            <br />
            • En el caso de los descuentos para cuentas Móvil Update y BYOP Credit Limit solo
            podrá redimir un cupón por factura. 
            <br />
            a. Si el valor del cupón de descuento redimido es mayor al balance
            pendiente de su factura Móvil Update o BYOP Credit Limit, al redimir
            este descuento el cliente perderá la diferencia del valor restante.
            <br />
            b. Si el valor del cupón de descuento redimido es menor al balance
            pendiente de su factura Móvil Update o BYOP Credit Limit, el cliente es
            responsable de pago remanente de su factura en o antes de la fecha de
            vencimiento
            <br />
            • Al momento de redimir su beneficio es importante que la cuenta NO esté
            suspendida o con atrasos. De estarlo, el cliente debe poner la cuenta al corriente
            para poder redimir su beneficio. 
            <br />
            • El beneficio expira en un período de 12 meses.
            <br />
            • La fecha de expiración del cupón de descuento será calculada tomando como inicio
            la fecha de envío del cupón.
            <br />
            • Cliente debe gestionar la redención de su cupón de descuento a través de Mi Claro.
            <br />
            • Claro no se hace responsable por cupones no redimidos por el cliente. 
            <br />
            3. Claro se reserva el derecho de modificar, a su sola discreción y de tiempo en tiempo, estos
            términos y condiciones y los términos aplicables serán aquellos que estén vigentes al
            momento de la redención o reclamación del beneficio
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <div
    class="basicrow text-center"
    style="display: inline-block; float: none; margin-top: 15px"
  >
    <div class="basicrow m-top">
      <div class="logline full"></div>
    </div>
    <div class="basicrow text-center m-top">
      <a class="btns def-i gray pull-left vcenter" (click)="this.getPdf(data)">
        <span class="tabcell">
          Imprimir&nbsp;&nbsp;<i
            class="fa fa-angle-right"
            aria-hidden="true"
          ></i>
        </span>
      </a>
      <a class="btns def-i red pull-right vcenter" (click)="this.close()">
        <span class="tabcell">
          Aceptar&nbsp;&nbsp;<i
            class="fa fa-angle-right"
            aria-hidden="true"
          ></i>
        </span>
      </a>
    </div>
  </div>
</div>
